/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { Subheader, CircularProgress, FontIcon, Chip, Avatar } from 'material-ui'
import { blue500 } from 'material-ui/styles/colors'

import * as constants from 'constants/Prestation'

class Availability extends React.Component {
  render () {
    return (
      <React.Fragment>
        <Subheader
          style={styles.subHeader}
        >
          {this.props.intl.formatMessage(constants.messages.PRESTATION_AVAILABILITIES)}
        </Subheader>

        <div
          style={styles.scrollable}
        >
          <div
            className='row'
          >
            <FontIcon
              style={{
                ...styles.badge,
                textAlign: 'center', cursor: 'pointer'
              }}
              className='material-icons'
              onClick={() => this.props.handleChangeAvailability(this.props.availabilities[0])}
            >
              expand_less
            </FontIcon>
          </div>

          {
            this.props.loadingAvailability
              ? <CircularProgress
                  size={50}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                />
              : <React.Fragment>
                {
                  this.props.availabilities.map((availability, index) => {
                    const availabilityStart = moment(availability.start).format('HH:mm')
                    const availabilityEnd = moment(availability.end).format('HH:mm')
                    const isSelected = availabilityStart === moment(this.props.start_time, 'HH:mm').format('HH:mm') &&
                                       availabilityEnd === moment(this.props.end_time, 'HH:mm').format('HH:mm')

                    return (
                      <div
                        className='row'
                        key={index}
                      >
                        <Chip
                          labelStyle={{textAlign: 'center', width: '100%'}}
                          onClick={() => this.props.handleTimeChange(availability)}
                          style={
                            isSelected
                              ? {backgroundColor: '#42617A', marginTop: 10, marginBottom: 10, width: '90%'}
                              : {marginTop: 10, marginBottom: 10, width: '90%'}
                          }
                        >
                          <Avatar
                            icon={
                              <FontIcon className='material-icons'>access_time</FontIcon>
                            }
                            color={blue500}
                            style={isSelected ? {backgroundColor: '#42617A'} : undefined}
                          />
                            <div style={isSelected ? {color: 'white'} : undefined}>
                              {availabilityStart} - {availabilityEnd}
                            </div>
                        </Chip>
                      </div>
                    )
                  })
                }
              </React.Fragment>
          }

          <div
            className='row'
          >
            <FontIcon
              style={{
                ...styles.badge,
                textAlign: 'center',
                cursor: 'pointer'
              }}
              className='material-icons'
              onClick={() => this.props.handleChangeAvailability(this.props.availabilities.at(-1))}
            >
              keyboard_arrow_down
            </FontIcon>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const styles = {
  subHeader: {
    textAlign: 'center',
    lineHeight: '20px',
    paddingTop: 10
  },
  badge: {
    padding: 0,
    paddingRight: 0,
    width: '90%'
  },
  scrollable: {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingLeft: 15,
    maxHeight: 550
  },
}

export default injectIntl(Availability)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/Availability.js